import { useBackgroundColor, UseBackgroundColorType } from '@stack/theme';

/**
 * hooks to get chip variant styles
 */
export const useChipVariantStyles = () => {
  const background: UseBackgroundColorType = useBackgroundColor();

  const colors: UseBackgroundColorType = {
    primary: { ...background.primaryLight },
    secondary: { ...background.secondaryLight },
    success: { ...background.successLight },
    error: { ...background.errorLight },
    warning: { ...background.warningLight },
    info: { ...background.infoLight },
  };

  return colors;
};
